import React from 'react';
import { Section, Link, Image, Logo, OnVisible } from 'components';
import { ReactComponent as PriceCircle } from 'images/price-circle.svg';
import { ReactComponent as InfoCircle } from '../../images/info-circle.svg';

import * as styles from './styles.module.scss';

const DrivaDifferenceFeatureGrid = (props) => {
  const { data } = props;
  const { primary, items } = data;

  const {
    title,
    description,
    check_icon: checkIcon,
    cross_icon: crossIcon,
    disclaimer_title: disclaimerTitle,
    disclaimer_content: disclaimerConent,
    cta_text: ctaText,
    cta_link: ctaLink,
  } = primary || {};

  // content checks
  const titleHtml = title?.html;
  const descriptionHtml = description?.html;
  const disclaimerTitleHtml = disclaimerTitle?.html;
  const disclaimerTitleText = disclaimerTitle?.text;
  const disclaimerContentHtml = disclaimerConent?.html;
  const hasCta = ctaText?.text && ctaLink?.url;

  const handleClick = (event, id) => {
    event.preventDefault();
    const anchorElement = document.getElementById(id);
    if (!anchorElement) return;

    const yOffset = -100;
    const y = anchorElement.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: 'smooth' });
  };

  return (
    <Section sliceName="DrivaDifferenceFeatureGrid" className={styles.section} containerClassName={styles.container}>
      <OnVisible visibleClassName={styles.visible} className={styles.background} as="figure" threshold="0.6">
        <img src="/images/curve-element.png" alt="Background" />
      </OnVisible>

      <header className={styles.header}>
        {titleHtml && <div dangerouslySetInnerHTML={{ __html: titleHtml }} className={styles.title} />}
        {descriptionHtml && (
          <div className={styles.description} dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
        )}
      </header>

      {/* table */}
      {items?.[0] && (
        <OnVisible visibleClassName={styles.visible} className={styles.table} as="table">
          <thead>
            <tr>
              <th className={styles.tableHeading}>Features</th>
              <th className={styles.columnHeading}>
                <Logo className={styles.logo} />
              </th>
              <th className={styles.columnHeading}>Traditional Leasing</th>
            </tr>
          </thead>

          <tbody>
            {items.map((item, index) => {
              const { add_info_icon: addInfoIcon = false } = item;
              return (
                <React.Fragment key={`driva-difference-feature-grid-row-${index}`}>
                  <tr className={styles.bodyRowMobile}>
                    <td colSpan={2} className={`${styles.tableCellHeading} ${styles.mobile}`}>
                      <div className={styles.tableHeadingContainer}>
                        <div className={styles.feature} dangerouslySetInnerHTML={{ __html: item.feature.html }} />
                        {addInfoIcon && (
                          <Link
                            className={styles.infoButton}
                            to={`#${disclaimerTitleText}`}
                            onClick={(event) => handleClick(event, disclaimerTitleText)}
                            key={disclaimerTitleText}
                          >
                            <InfoCircle className={styles.infoIcon} />
                          </Link>
                        )}
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td className={`${styles.tableCellHeading} ${styles.desktop}`}>
                      <div className={styles.tableHeadingContainer}>
                        <div dangerouslySetInnerHTML={{ __html: item.feature.html }} />
                        {addInfoIcon && (
                          <Link
                            className={styles.infoButton}
                            to={`#${disclaimerTitleText}`}
                            onClick={(event) => handleClick(event, disclaimerTitleText)}
                            key={disclaimerTitleText}
                          >
                            <InfoCircle className={styles.infoIcon} />
                          </Link>
                        )}
                      </div>
                    </td>
                    <td className={styles.tableCell}>
                      <Image image={checkIcon} className={styles.icon} />
                    </td>
                    <td className={styles.tableCell}>
                      <Image image={crossIcon} className={styles.icon} />
                    </td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </OnVisible>
      )}

      <footer className={styles.footer}>
        {disclaimerTitleHtml && (
          <div className={styles.disclaimerTitleAndIcon} id={disclaimerTitleText}>
            <PriceCircle className={styles.priceCircle} />
            <div className={styles.disclaimerTitle} dangerouslySetInnerHTML={{ __html: disclaimerTitleHtml }} />
          </div>
        )}
        {disclaimerContentHtml && (
          <div className={styles.disclaimerContent} dangerouslySetInnerHTML={{ __html: disclaimerContentHtml }} />
        )}
      </footer>

      {hasCta && (
        <Link className={`button ${styles.cta}`} to={ctaLink?.url}>
          {ctaText?.text}
        </Link>
      )}
    </Section>
  );
};

export default DrivaDifferenceFeatureGrid;
